import React from 'react';
import './NotificationsList.css';

/**
 * Компонент отдельного уведомления
 * @param {object} notification - Объект уведомления
 * @param {function} onMarkAsRead - Функция для отметки прочитанным
 * @param {function} onShowInvitePath - Функция для показа пути приглашений
 * @param {function} onDeleteNotification - Функция для удаления уведомления
 * @param {function} onReplyToNotification - Функция для ответа на уведомление
 */
const NotificationItem = ({ notification, onMarkAsRead, onShowInvitePath, onDeleteNotification, onReplyToNotification }) => {
  const { id, sender_name, sender_telegram_id, sender_avatar, message, timestamp, is_read } = notification;
  
  // Форматирование даты
  const formatDate = (isoString) => {
    try {
      const date = new Date(isoString);
      return date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return isoString;
    }
  };

  // Обработчик клика на кнопку "Прочитано"
  const handleMarkAsRead = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onMarkAsRead && !is_read) {
      onMarkAsRead(id);
    }
  };

  // Обработчик клика на аватар или имя
  const handleShowInvitePath = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onShowInvitePath) {
      onShowInvitePath(sender_telegram_id);
    }
  };

  // Обработчик для кнопки "Ответить"
  const handleReply = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onReplyToNotification) {
      onReplyToNotification(notification);
    }
  };

  // Обработчик для кнопки "Удалить"
  const handleDelete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onDeleteNotification) {
      onDeleteNotification(id);
    }
  };

  // Определение URL аватарки
  let avatarSrc = '/avatars/default-avatar.png'; // Дефолтный путь
  if (sender_avatar) {
    if (sender_avatar.startsWith('/')) {
      avatarSrc = sender_avatar; // Путь уже правильный
    } else if (sender_avatar.startsWith('avatars/')) {
      avatarSrc = '/' + sender_avatar; // Добавляем слеш
    }
  }

  return (
    <div className={`card notification-item ${is_read ? 'notification-read' : 'notification-unread'}`} style={{ marginBottom: '15px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleShowInvitePath}>
          <div className="user-avatar" style={{ width: '40px', height: '40px', marginRight: '10px' }}>
            {sender_avatar ? (
              <img 
                src={avatarSrc} 
                alt={sender_name || "Отправитель"} 
                onError={(e) => {e.target.onerror = null; e.target.src = '/avatars/default-avatar.png';}}
              />
            ) : (
              <div className="placeholder"></div>
            )}
          </div>
          <div>
            <div className="user-name" style={{ fontSize: '14px' }}>{sender_name}</div>
            <div className="subtle-text" style={{ fontSize: '12px' }}>{formatDate(timestamp)}</div>
          </div>
        </div>
        
        {!is_read && (
          <div className="status-badge" style={{ 
            backgroundColor: 'var(--accent-primary)', 
            color: 'white', 
            border: 'none', 
            fontSize: '9px',
            padding: '3px 6px'
          }}>
            Новое
          </div>
        )}
      </div>
      
      <div style={{ padding: '5px 0 15px', width: '100%', maxWidth: '100%' }}>
        {message ? (
          <p style={{ 
            wordWrap: 'break-word', 
            overflowWrap: 'break-word', 
            wordBreak: 'break-word',
            maxWidth: '100%'
          }}>{message}</p>
        ) : (
          <p className="subtle-text">
            Пользователь хочет связаться с вами в Telegram
          </p>
        )}
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        {onReplyToNotification && (
          <button 
            className="button"
            onClick={handleReply}
            style={{ padding: '8px 15px', fontSize: '12px' }}
          >
            Ответить
          </button>
        )}

        {onDeleteNotification && (
          <button 
            className="button"
            onClick={handleDelete}
            style={{ padding: '8px 15px', fontSize: '12px', backgroundColor: '#E8A87C', color: '#ffffff' }}
          >
            Удалить
          </button>
        )}

        {!is_read && onMarkAsRead && (
          <button 
            className="button"
            onClick={handleMarkAsRead}
            style={{ padding: '8px 15px', fontSize: '12px' }}
          >
            Отметить прочитанным
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationItem; 